import { SET_IS_COOKIE_HIDDEN } from './actions';

const setIsCookieHidden = (state, { storageValue = true }) => ({
  ...state,
  isCookieHidden: storageValue,
});

const reducer = {
  [SET_IS_COOKIE_HIDDEN]: setIsCookieHidden,
};

const initialState = {
  isCookieHidden: true,
};

export default (state = initialState, action) => {
  const newState = !state.hydrated ? { ...initialState, ...state, hydrated: true } : state;

  return action.type && reducer[action.type] ? reducer[action.type](state, action) : newState;
};
